import React, { useEffect } from 'react';
import throttle from 'lodash/throttle';
import Auth from '@Services/Auth';

export default function UserActivityWatcher() {
  useEffect(() => {
    const eventsToWatch = ['mousemove', 'keydown', 'DOMMouseScroll', 'mousewheel', 'mousedown', 'touchstart', 'touchmove'];
    const THROTTLE_TIMEOUT = 1000;

    function updateTiming() {
      Auth.setLastActionTime();
    }

    const throttledHandler = throttle(updateTiming, THROTTLE_TIMEOUT);

    function bindToElement(element) {
      eventsToWatch.forEach((eventName) => {
        element.addEventListener(eventName, throttledHandler, true);
      });
    }

    function unbindFromElement(element) {
      eventsToWatch.forEach((eventName) => {
        element.removeEventListener(eventName, throttledHandler, true);
      });
    }

    bindToElement(document);

    return () => {
      unbindFromElement(document);
    };
  }, []);

  return null;
}
